import TrendingDown from "plos/src/img/icons/trending-down.svg?react";
import TrendingUp from "plos/src/img/icons/trending-up.svg?react";
import { ownershipIconWrapper } from "../elementOverlayValue.css";

interface OwnershipIconProps {
  transfersIn: number;
  transfersOut: number;
}

const OwnershipIcon = ({ transfersIn, transfersOut }: OwnershipIconProps) => {
  if (transfersIn === transfersOut) {
    return null;
  }

  return (
    <div className={ownershipIconWrapper}>
      {transfersIn > transfersOut ? <TrendingUp /> : <TrendingDown />}
    </div>
  );
};

export default OwnershipIcon;
